function validateConfig(regions, config){
    return new Promise((resolve, reject) => {
        const queue = Object.keys(regions).map(id=>{
            return {
                id: id,
                region: regions[id],
                config: config[id]
            }
        })
        while(queue.length>0){
            const work = queue.shift()
            if(!work.config||!work.config.config){
                reject(new Error('请配置'+work.region.name))
                return
            }
            for(const id in work.region.config){
                const config = work.region.config[id]
                if(config.required&&!work.config.config[id]){
                    reject(new Error('请配置'+work.region.name+'的'+config.name))
                    return
                }
            }
            if(work.region.subRegions){
                queue.push(...Object.keys(work.region.subRegions).map(id=>{
                    return {
                        id: id,
                        region: work.region.subRegions[id],
                        config: work.config.subRegionConfigs[id]
                    }
                }))
            }
        }
        resolve()
    })
}

export default {
    validateConfig
}
